import React from 'react';
import { useTranslation } from 'react-i18next';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import SettingsBrightnessOutlinedIcon from '@mui/icons-material/SettingsBrightnessOutlined';
import { useThemeMode } from '../../theme/ThemeProvider';
import { THEMES, canUseDarkMode } from '../../utils/theme';
import styles from './ThemeToggle.module.scss';

const OPTIONS = [
    { id: THEMES.LIGHT, Icon: LightModeOutlinedIcon, labelKey: 'theme.light' },
    { id: THEMES.SYSTEM, Icon: SettingsBrightnessOutlinedIcon, labelKey: 'theme.system' },
    { id: THEMES.DARK, Icon: DarkModeOutlinedIcon, labelKey: 'theme.dark' },
];

/**
 * Segmented light / system / dark control.
 * Only rendered for roles allowed by canUseDarkMode() (and on the login screen).
 */
const ThemeToggle = ({ size = 'md', className = '' }) => {
    const { t } = useTranslation();
    const { preference, setPreference } = useThemeMode();

    if (!canUseDarkMode()) {
        return null;
    }

    return (
        <div
            className={`${styles.themeSwitcher} ${styles[`size_${size}`]} ${className}`}
            role="group"
            aria-label={t('theme.chooser')}
        >
            {OPTIONS.map(({ id, Icon, labelKey }) => {
                const active = preference === id;
                return (
                    <button
                        key={id}
                        type="button"
                        className={`${styles.themeBtn} ${active ? styles.themeBtnActive : ''}`}
                        onClick={() => setPreference(id)}
                        aria-pressed={active}
                        aria-label={t(labelKey)}
                        title={t(labelKey)}
                    >
                        <Icon className={styles.icon} />
                    </button>
                );
            })}
        </div>
    );
};

export default ThemeToggle;
